import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class BuscarExpurgoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }


  getAllDocs() {
    return this.httpClient.get(this.apiURL + '/situacao-documental', this.httpOptions);
  }

  searchSituacaoDoc(arrayPesquisa, clienteId): Observable<any> {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.post<any>(this.apiURL + `/situacao-documental/buscar/${clienteId}`, arrayPesquisa, {headers});
  }

  downloadRelatorio(arrayPesquisa) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.post(this.apiURL + `/situacao-documental/download`, arrayPesquisa, {headers,  responseType: 'blob'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/buscarExpurgo/buscar-expurgo.service.ts